import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import axios from 'axios';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    "name": '',
    "phone": '',
    "email": '',
    "enquiry": '',
    "carName": '', // Added field for car name
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!formData.name || !formData.phone || !formData.enquiry) {
      setError('Name, phone number, and enquiry are required.');
      return;
    }

    try {
      const response = await axios.post('https://therentalz.thetrippingcompany.com/api/server', formData);
      setSuccessMessage(response.data.message);
      setFormData({ name: '', phone: '', email: '', enquiry: '', carName: '' }); // Reset form data
    } catch (error) {
      console.error(error);
      setError('Failed to send the enquiry. Please try again.');
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        maxWidth: '600px', // Reduced width for a smaller form
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: 3,
        backgroundColor: '#ffffff', // White background for contrast
        borderRadius: '8px',
        boxShadow: 2,
      }}
    >
      <Typography variant="h5" component="h2" align="center" gutterBottom>
        Want Us To Reach Out? <br/>Fill Your Details:
      </Typography>
      {error && (
        <Typography color="error" align="center">
          {error}
        </Typography>
      )}
      {successMessage && (
        <Typography color="primary" align="center">
          {successMessage}
        </Typography>
      )}
      <TextField
        label="Name"
        variant="outlined"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
      />
      <TextField
        label="Phone Number"
        variant="outlined"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        required
      />
      <TextField
        label="Car Name" // New field for car name
        variant="outlined"
        name="carName"
        value={formData.carName}
        onChange={handleChange}
      />
      <TextField
        label="Email"
        variant="outlined"
        name="email"
        value={formData.email}
        onChange={handleChange}
        type="email"
      />
      <TextField
        label="Enquiry"
        variant="outlined"
        name="enquiry"
        value={formData.enquiry}
        onChange={handleChange}
        multiline
        rows={4}
        required
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
      >
        Submit
      </Button>
    </Box>
  );
};

export default ContactForm;
